module.exports = __webpack_public_path__ + "img/qrcode.443aa7c0.png";